import { ApprovalQueue } from "../features/approval-queue";

const ApprovalRequests = () => <ApprovalQueue />;

export default ApprovalRequests;
